import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";

/*
 *@author   tonicli
 *@date     2017/5/10
 */
var UA = navigator.userAgent;
var PT = navigator.platform;

var _isIphone = UA.indexOf('iPhone') >= 0;

var _isIpad = /(iPad).*OS\s([\d_]+)/.test(UA);

var _isIos = _isIphone || _isIpad;

var _isAndroid = UA.indexOf('Android') >= 0;

var _isApad = _isAndroid && UA.indexOf('Mobile') < 0;

var _isMac = PT.indexOf('Mac') === 0;

var _isWin = UA.indexOf('Windows') >= 0;

var _isMqq = /QQ\/([\d.]+)/.test(UA);

var _isWechat = UA.indexOf('MicroMessenger') >= 0 && UA.indexOf('wxwork') < 0;

var _isWeChatMiniProgram = UA.indexOf('MicroMessenger') >= 0 && (window.__wxjs_environment === 'miniprogram' || UA.match(/miniprogram/i));

var _isApp = /(QQLive|WeTV)(HD|Kid)?(Browser|_MAC)?[\s/]*(\d+(\.\d+)*)/i.test(UA);

var _isKidApp = UA.indexOf('QQLiveKidBrowser') >= 0;

var _isWetv = _isApp && UA.indexOf('WeTVBrowser') >= 0;

var isLiteApp = _isApp && UA.indexOf('QQLiteBrowser') >= 0;

var isBaseApp = UA.indexOf('QQLiveBrowser') >= 0 && !isLiteApp;
var isLocalPkg = _isApp && typeof location !== 'undefined' && !/^http(s)?:/.test(location.protocol);
var isHDApp = UA.indexOf('QQLiveHDBrowser') >= 0; // QQ浏览器

var _isMqb = _isIos ? /mqqbrowser/gi.test(UA) : window.qb_bridge || !!(window.mtt && window.mtt.getBrowserParam);

var _isPCClient = /QQLive\/\d+/.test(UA);

var env = {
  isIos: _isIos,
  isIphone: _isIphone,
  isIpad: _isIpad,
  isAndroid: _isAndroid,
  isApad: _isApad,
  isMac: _isMac,
  isWin: _isWin,
  isMqq: _isMqq,
  isWechat: _isWechat,
  isApp: _isApp,
  isKidApp: _isKidApp,
  isWetv: _isWetv,
  isMqb: _isMqb,
  isPCClient: _isPCClient,
  isWeb: !_isIphone && !_isAndroid && !_isIpad && !_isApad && !/(WebOS|BlackBerry)/.test(UA),
  os: 'other',
  app: 'browser',
  device: 'unknown',
  isLiteApp: isLiteApp,
  isBaseApp: isBaseApp,
  isLocalPkg: isLocalPkg,
  isWeChatMiniProgram: _isWeChatMiniProgram,
  isHDApp: isHDApp
};
env.os = env.isIos ? 'ios' : env.isAndroid ? 'android' : 'other';

if (isBaseApp) {
  env.app = 'app';
} else if (_isWechat) {
  env.app = 'wechat';
} else if (_isMqq) {
  env.app = 'mqq';
} else if (_isKidApp) {
  env.app = 'kidapp';
} else if (_isMqb) {
  env.app = 'qqbrowser';
} else if (_isPCClient) {
  env.app = 'client';
} else if (isLiteApp) {
  env.app = 'liteapp';
}

if (_isIphone) {
  env.device = 'iphone';
} else if (_isIpad) {
  env.device = 'ipad';
} else if (_isApad) {
  env.device = 'apad';
} else if (_isAndroid) {
  env.device = 'aphone';
} else if (_isMac) {
  env.device = 'mac';
} else if (_isWin) {
  env.device = 'windows';
}

export default env;